import { ExternalReturnHubType } from "@redotech/account-common/address";
import { BlueYonderZod } from "../../../return";

interface AddressWithBlueYonderLocation {
  blueYonderLocationId?: string | null;
  externalReturnHub?: {
    provider: ExternalReturnHubType;
    locationId?: string | null;
  } | null;
}

/**
 * Resolves the BlueYonder destination location ID from a merchant address.
 * Prefers externalReturnHub.locationId when the hub provider is BlueYonder,
 * falls back to blueYonderLocationId on the address itself.
 * Returns undefined if neither is present — callers should treat this as
 * "BlueYonder not configured for this address" and return no locations.
 */
export function getBlueYonderLocationId(
  address: AddressWithBlueYonderLocation,
): string | undefined {
  if (
    address.externalReturnHub?.provider === ExternalReturnHubType.BLUEYONDER
  ) {
    return address.externalReturnHub.locationId ?? undefined;
  }
  return address.blueYonderLocationId ?? undefined;
}

interface ReturnWithBlueYonder {
  blueYonder?: BlueYonderZod | null;
}

/**
 * @deprecated `return.blueYonder` is deprecated. Use the `dropoffs.qrCodes`
 * path (e.g. `getDropoffQrCodeByProvider(trackable, BLUE_YONDER_PROVIDER)`)
 * instead.
 */
export function isBlueYonderChosen(return_: ReturnWithBlueYonder): boolean {
  return !!return_.blueYonder?.chosen;
}
